// middleware/admin.js
import { watch } from 'vue';
export default defineNuxtRouteMiddleware(async (to) => {
  if (!to.path.startsWith('/manage') || to.path === '/manage/login') return;

  if (process.server) return;

  const { $supabase } = useNuxtApp();
  const { useUserStore } = await import('~/stores/user');
  const userStore = useUserStore();

  // ✅ Skip if already verified
  if (userStore.isAdmin) return;

  // ✅ Wait for auth with timeout safety
  if (userStore.loading) {
    await Promise.race([
      new Promise((resolve) => {
        const unwatch = watch(
          () => userStore.loading,
          (isLoading) => {
            if (!isLoading) {
              unwatch();
              resolve();
            }
          }
        );
      }),
      new Promise((resolve) => setTimeout(resolve, 3000)),
    ]);
  }

  const {
    data: { session },
  } = await $supabase.auth.getSession();
  if (!session) return navigateTo('/manage/login');

  try {
    const { data, error } = await $supabase.functions.invoke('check-admin');
    if (error || !data?.isAdmin) {
      userStore.isAdmin = false;
      return navigateTo('/manage/login');
    }
    userStore.isAdmin = true;
  } catch {
    return navigateTo('/manage/login');
  }
});
